// extracted by mini-css-extract-plugin
export var button = "styles-module--button--dd910";
export var disabled = "styles-module--disabled--ab1d3";
export var left = "styles-module--left--f6ba0";
export var right = "styles-module--right--81aed";